import ReactQuill from 'react-quill';
import '../../utils/highlight';
import EditorToolbar, { formats } from './EditorToolbar';
import { StyledEditor } from './styles';
//
import { EditorProps } from './types';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

export default function Editor({
  id = 'minimal-quill',
  error,
  value,
  onChange,
  simple = false,
  helperText,
  sx,
  ...other
}: EditorProps) {
  const modules = {
    toolbar: {
      container: `#${id}`,
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true,
    },
    syntax: false,
    clipboard: {
      matchVisual: false,
    },
  };

  const { translate } = useLocales();

  return (
    <>
      <StyledEditor
        sx={{
          ...(error && {
            border: (theme) => `solid 1px ${theme.palette.error.main}`,
          }),
          ...sx,
        }}
      >
        <EditorToolbar id={id} isSimple={simple} />

        <ReactQuill
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={`${translate('productsPage.descriptionPlaceHolder')}`}
          {...other}
        />
      </StyledEditor>

      {helperText && helperText}
    </>
  );
}
